export const SnackBarType = {
  DEFAULT: 'default',
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

export const ModalType = {
  ALERT_MODAL: 'ALERT_MODAL',
  DIALOG_TEXT: 'DIALOG_TEXT',
  AWARD_MODAL: 'AWARD_MODAL',
  UPLOAD_DIALOG: 'UPLOAD_DIALOG',
  CHECK_PRODUCT_MODAL: 'CHECK_PRODUCT_MODAL',
  CHECK_EMBEDDING_MODAL: 'CHECK_EMBEDDING_MODAL',
};

export const OrganzationStatusType = {
  INITIAL: 'INITIAL',
  QUERYING: 'QUERYING',
  QUERYING_SUCCESS: 'QUERYING_SUCCESS',
  QUERYING_FAILURE: 'QUERYING_FAILURE',
};

export const PlatformType = {
  LINE: 'line',
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  WHATSAPP: 'whatsapp',
  LIVECHAT: 'livechat',
};

export const ImagemapTemplateType = {
  ImagemapTemplate1: [
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '0%',
      y: '0%',
      width: '100%',
      height: '100%',
    },
  ],
  ImagemapTemplate2: [
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '0%',
      y: '0%',
      width: '100%',
      height: '50%',
    },
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '0%',
      y: '50%',
      width: '100%',
      height: '50%',
    },
  ],
  ImagemapTemplate3: [
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '0%',
      y: '0%',
      width: '100%',
      height: '50%',
    },
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '0%',
      y: '50%',
      width: '50%',
      height: '50%',
    },
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '50%',
      y: '50%',
      width: '50%',
      height: '50%',
    },
  ],
  ImagemapTemplate4: [
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '0%',
      y: '0%',
      width: '50%',
      height: '50%',
    },
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '50%',
      y: '0%',
      width: '50%',
      height: '50%',
    },
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '0%',
      y: '50%',
      width: '50%',
      height: '50%',
    },
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '50%',
      y: '50%',
      width: '50%',
      height: '50%',
    },
  ],
  ImagemapTemplate5: [
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '0%',
      y: '0%',
      width: '50%',
      height: '50%',
    },
  ],
};

export const MitakeAccountType = {
  B2C: 'b2c',
  B2B: 'b2b',
};

export const RecurringMessageFrequencyType = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
};

export const RecurringMessageStatus = {
  DRAFT: 'draft',
  ENABLED: 'enabled',
  DISABLED: 'disabled',
};

export const NotifyRecipientType = {
  PAGE: 'fromPage',
  LINE: 'fromLine',
  ALL: 'all',
};

export const LoginResultAwardMethod = {
  COUPON: 'coupon',
  GAME: 'game',
};

export const GameType = {
  COUPON: 'coupon',
  ROULETTE: 'roulette',
  SCRATCH: 'scratch',
  SLOTMACHINE: 'slotmachine',
};

export const GPTModelType = {
  BEDROCK_CLAUDE_SONNET: 'claude-3-7-sonnet',
  BEDROCK_CLAUDE_HAIKU: 'claude-3-5-haiku',
  GPT35: 'gpt-3.5-turbo',
  GPT4O: 'gpt-4o',
  GPT4TURBO: 'gpt-4-turbo',
  GPT41: 'gpt-4.1',
};

export const GPTModelTypePoints = {
  BEDROCK_CLAUDE_SONNET: 3,
  BEDROCK_CLAUDE_HAIKU: 1,
  GPT35: 1,
  GPT4O: 3,
  GPT4TURBO: 5,
  GPT41: 10,
};

export const ModelProvider = {
  'claude-3-7-sonnet': 'bedrock',
  'claude-3-5-haiku': 'bedrock',
  'gpt-3.5-turbo': 'azure',
  'gpt-4o': 'openai',
  'gpt-4-turbo': 'openai',
  'gpt-4': 'azure',
};

export const sortType = {
  ASC: 'asc',
  DESC: 'desc',
};

export const VendorStore = {
  BOT_KEYWORD: 'keyword',
  BOT_OFFLINE: 'offline',
  BOT_WELCOME: 'welcome',
  BOT_EXCUTOR: 'bot_excutor',
  BOT_IMAGE: 'bot_image_render',
  BOT_EDITOR: 'bot_editor',
  SUPER_LINK_VENDOR_ID: 'superlink',
  GROWTH_TOOL_VENDOR_ID: 'growth_tool',
  ROULETTE_VENDOR_ID: 'game_module_roulette',
  MA_VENDOR_ID: 'marketing_automation',
  SCRATCH_VENDOR_ID: 'game_module_scratch',
  SLOTMACHINE_VENDOR_ID: 'game_module_slot',
  COUPON_VENDOR_ID: 'coupon_module',
  RICH_MENU_VENDOR_ID: 'rich_menu_editor',
  PNP_VENDOR_ID: 'infobip',
  SUPER8: 'super8',
  EINVOICE_VENDOR_ID: 'eInvoice',
  NUMBER8_NEXT: 'number8_next',
};
